<template>
    <StepShell :embedded="embedded" width="wide">
        <StepHeader :align="embedded ? 'start' : 'center'" :size="embedded ? 'step' : 'display'" title="My coaching gets sharper the more I know">
            Same as a coach in real life. The first conversation is educated guesswork; the tenth is specific because they know you by then. So here is an honest picture of how
            well I know you today.
        </StepHeader>

        <ContextPanel :dimensions="context.dimensions" :percent="context.percent" :size="embedded ? 196 : 260" />

        <StepActions flush>
            <template #start>
                <p class="reassurance">
                    <i aria-hidden="true" class="bi bi-lock"></i>
                    Everything I learn stays private to you, always.
                </p>
            </template>
            <BaseButton theme="primary" @click="emit('continue')">
                {{ embedded ? "Continue" : "Get started" }}
                <i aria-hidden="true" class="bi bi-arrow-right"></i>
            </BaseButton>
        </StepActions>
    </StepShell>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import ContextPanel from "~vue/ProfileSetup/ContextPanel.vue";
import type { ContextSnapshot } from "~vue/ProfileSetup/types";

import StepActions from "./StepActions.vue";
import StepHeader from "./StepHeader.vue";
import StepShell from "./StepShell.vue";

/*
 * Use server scoring exclusively. Client defaults previously became stale immediately after users answered
 * the preceding screen.
 */
const { embedded = false } = defineProps<{ context: ContextSnapshot; embedded?: boolean }>();

const emit = defineEmits<{ continue: [] }>();
</script>

<style scoped>
@reference "../../../css/tailwind.css";
@layer components {
    .reassurance {
        @apply details flex items-center gap-2 text-ink-muted;
    }
}
</style>
